<template>
  <div>
    <div class="content-header">
      <div>
        <h1>客户资产与消费&还款分析报告</h1>
      </div>
      <div class="content-title-info">
        <Row>
          <Col :span="2"></Col>
          <Col :span="4">
            <span>姓名: &nbsp;{{ dataMap.custom.name }}</span>
          </Col>
          <Col :span="8">
            <Icon type="ios-archive" size="24"/>
            <span>数据来源: &nbsp;</span>
            <span v-for="(bank, i) in homeStat.billTypeList" :key="`bank-${i}`"
                  style="font-size: medium"> &nbsp;  <Icon type="ios-copy"/> {{ bank }} &nbsp;</span>
          </Col>

          <Col :span="10">
            <Icon type="ios-clock"/>
            <span>账单周期: &nbsp;</span>
            <span style="font-size: medium"> &nbsp; {{ homeStat.startTime }} 到{{
                homeStat.endTime
              }} 合计:<span>{{ homeStat.statMonth }}</span> 个月 </span>
          </Col>
        </Row>
      </div>
    </div>
    <div style="background: #eee;padding: 10px;margin: 10px;">
      <Card :bordered="false" style="width: 100%">
        <Row>
          <Col span="6">
            <h2>信用风险评分</h2>
            <p style="font-size: 50px;color: #348EED">{{ score.creditRatingScore }}</p>
          </Col>
          <Col span="6">
            <p>评分越高,客户信用越好,<br>35分以下建议决绝<br>35-45分慎重评估<br>45-70分综合评估<br>70以上建议通过</p>
          </Col>
          <Col span="6">
            <h2>还款能力评分</h2>
            <p style="font-size: 50px;color: #348EED">{{ score.consumptionCapacityScore }}</p>
          </Col>
          <Col span="6" style="padding-top: 20px;">
            <p>评分依据收/消费/资产等计算</p>
            <p>评分越高,还款能力越强</p>
            <p>依据客户购买车价综合评估</p>
          </Col>
        </Row>
      </Card>
    </div>
    <div style="background: #eee;padding: 10px;margin: 10px;">
      <Card :bordered="false" style="width: 100%">
        <Row>
          <Col span="12">
            <h3>风险命中数量</h3>
            <p style="font-size: 30px;color: red">{{ homeStat.hitRiskListNum }}</p>
          </Col>
          <Col span="12">
            <h3>风险提示</h3>
            <p v-for="(item, index) in homeStat.riskDetailList" :key="index">{{ item }}</p>
          </Col>
        </Row>
      </Card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'content-title',
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object
  },
  data () {
    return {
      index
    }
  },
  methods: {
    setData (dataMap, homeStat) {
      this.dataMap = dataMap
      this.homeStat = homeStat
    }
  }
}
</script>
<style>
.content-header {
  vertical-align: center;
  text-align: center;
  width: 100%;
  padding-top: 5px;
  background-color: #5c9ade;
  color: #ffffff;
}

.content-title-info {
  margin-top: 15px;
}

</style>
